import { render, staticRenderFns } from "./SlidePromoFlexible.vue?vue&type=template&id=fb5da2cc&"
import script from "./SlidePromoFlexible.vue?vue&type=script&lang=js&"
export * from "./SlidePromoFlexible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports